import { useInfiniteQuery } from "@tanstack/react-query";
import { useAppContext } from "@web/route-services/root/AppContext";

export const chatPreviewQueryKey = ["chatPreview"];
const pageSize = 25;

export function useChatPreviewQuery() {
  const { access } = useAppContext();

  return useInfiniteQuery({
    queryKey: chatPreviewQueryKey,
    queryFn: async ({ pageParam = 0 }) => {
      const response = await access.chat.getPreviewPage({
        page: pageParam,
        pageSize
      });
      return response;
    },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.length < pageSize) return undefined;
      return (lastPageParam as number) + 1;
    },
    initialPageParam: 0
  });
}
